/// <reference path='references.ts' />

let errorDialogOpen = false;
let errorQueue: string[] = [];

function logJavascriptError(msg: string, stackframes: StackTrace.StackFrame[]) {

    let stackTraceStr = msg + '\n' + stackframes.map(function(stackframe) {
        return '\t' + stackframe.toString();
    }).join('\n');

    // only show one error dialog at a time
    if(!errorDialogOpen) {
        showErrorDialog(stackTraceStr);
    }
    else {
        errorQueue.push(stackTraceStr);
    }
}

function showErrorDialog(stackTraceStr: string, fromQueue = false) {

    let idErrorLog = '...';
    let $dialog = $('<div></div>');
    let href = window.location.href;
    // Request mapping is everything after /fpm with the IDs replaced with placeholder
    let requestMapping = href.substr(href.indexOf('/fpm') + 4).replace(/\/\d+\//, '/{id}/');
    // only show stack trace in Dev and Test
    let showException = href.indexOf('localhost') > 0 || href.indexOf(':8080') > 0 || href.indexOf('trackit-test') > 0;
    // record the error in the error logs
    $.ajax({
        url: url('/errorLogs/'),
        type: 'POST',
        dataType: 'json',
        traditional: true,
        data: {
            'requestDate': moment().format('YYYY-MM-DD HH:mm'),
            'errorMessage': stackTraceStr.substr(0, stackTraceStr.indexOf('\n')),
            'handler': 'JavaScript',
            'requestMapping': requestMapping,
            'stacktrace': stackTraceStr
        },
        success: function(data) {
            idErrorLog = data.idErrorLog;
            // dialog may already be created so replace placeholder value;
            $dialog.find('p .ui-icon-text').each(function(){
                let $p = $(this);
                if ($p.text().indexOf('...') > 0) {
                    $p.text($p.text().replace(/\.\.\./, idErrorLog));
                }
            });
        }
    });

    // display error dialog
    errorDialogOpen = true;
    let $suppressCheckbox;
    $dialog.builddialog({
        title: 'Error',
        dialogOptions: {
            close: function(){
                errorDialogOpen = false;
                if ($suppressCheckbox != null && $suppressCheckbox.is(':checked')) {
                    errorQueue = [];
                }
                if(errorQueue.length > 0) {
                    showErrorDialog(errorQueue.shift(), true);
                }
            }
        }
    });
    $dialog.builddialog('error', {
        'text': translate('Unfortunately an application error has occurred at {0}', [moment().format('Do MMMM YYYY HH:mm:ss Z')]),
        'translateText': false,
        'bold': true
    });
    $dialog.builddialog('error', {
        'text': translate('Please use the following reference when contacting your local help desk: {0}', [idErrorLog]),
        'translateText': false
    });
    if (showException) {
        $dialog.builddialog('custom', {
            '$row': $('<div style="width:100%;max-height:500px;overflow-y:scroll;"><pre class="error stack-trace"><code>' + stackTraceStr + '</code></pre></div>')
        });
    }

    if (fromQueue) {
        let $suppress = $('<div></div>');
        $suppressCheckbox = $('<input type="checkbox" value="true" name="suppress-errors" id="suppress-errors" />');
        $suppress.append($suppressCheckbox);
        $suppress.append($('<label for="suppress-errors"> ' + translate("Don't let this page create more error messages") + '</label>'));
        $dialog.builddialog('custom', {
            '$row': $suppress
        });
    }
    $dialog.builddialog('show');
    if ($suppressCheckbox != null) {
        $suppressCheckbox.blur();
    }
}

window.onerror = function(msg: string, url: string, line: number, col: number, error: Error){

    StackTrace.fromError(error).then(function(stackframes: StackTrace.StackFrame[]) {
        logJavascriptError(msg, stackframes);
    })['catch'](function(err) {
        alert(err.message);
    });
};
